<template>
    <div class="fieldset">
        <slot></slot>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.fieldset {
    font-size: 16px;
    font-weight: 600;
    color: #007bff;
    padding: 12px 0;
    border-bottom: 1px solid #dbdbdb;
}
</style>